module.exports = __webpack_public_path__ + "static/media/AshevilleHempFarmsSandwichboardsigninprogress2019.23ee0fb9.webp";